import React, { useState, useEffect } from "react";

import { withTranslation } from "react-i18next";
import {Alert, Button, Card, Form} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faFile} from "@fortawesome/free-solid-svg-icons";
import {faTrash} from "@fortawesome/fontawesome-free-solid";

const HclViewerTerraformConfiguration = ({ content = {}, handleUpdate, t, instanceTemplate }) => {

  const [data, setData] = useState("");
  const [isInvalidConfiguration, setIsInvalidConfiguration] = useState(false);
  const fileReader = new FileReader();
  fileReader.onload = handleReadData;

  useEffect(() => {
    try {
      const parsedConfiguration = JSON.parse(content);
      setData(parsedConfiguration.static.seb_configuration);
    } catch (error) {
      console.error("Failed to parse json string");
    }
  }, [content]);

  async function handleSEBConfigurationDownload(){
    try {
      const res = await fetch(`data:application/seb;base64,${data}`);
      const blob = await res.blob();
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      a.href = window.URL.createObjectURL(blob);
      a.setAttribute("download", `${instanceTemplate.name}.seb`);
      a.click();
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    }catch (err){
      console.log(err);
    }
  }

  async function handleReadData(){
    const xmlStartSequence = "<?xml";
    setIsInvalidConfiguration(false);
    try {
      const resource = await fetch(fileReader.result);
      const dataBlob = await resource.blob();
      const gzipBlob = dataBlob.slice();
      let possibleXMLSEBConfiguration = await dataBlob.text();
      if (possibleXMLSEBConfiguration.substring(0, 5) !== xmlStartSequence) {
        // It is not plain text -> Gzip compressed
        //eslint-disable-next-line
        const ds = new DecompressionStream("gzip");
        const decompressedStream = gzipBlob.stream().pipeThrough(ds);
        const responseBlob = await new Response(decompressedStream).blob();
        possibleXMLSEBConfiguration = await responseBlob.text();
        if (possibleXMLSEBConfiguration.substring(0, 5) !== xmlStartSequence) {
          setIsInvalidConfiguration(true);
          return;
        }
      }
      setIsInvalidConfiguration(false);
      const base64EncodedData = btoa(possibleXMLSEBConfiguration);
      setData(base64EncodedData);
      handleUpdate(base64EncodedData);
      return;
    } catch (err) {
      console.error(err);
    }
    setIsInvalidConfiguration(true);
  }

  function handleUpload(event) {
    console.log(event.target.files[0]);
    fileReader.readAsDataURL(event.target.files[0]);
  }


  return (<div>
    {isInvalidConfiguration ? (
        <Alert variant="danger">
          {t(
              "SingleInstanceTemplate.ConfigurationTab.SEBUploadInvalidFile"
          )}
        </Alert>
    ) : (
        ""
    )}
    {!data || data.length < 1 ? (
    <Form.Group>
      <Form.File custom>
        <Form.File.Input
            onChange={handleUpload}
            accept=".seb"
        />
        <Form.File.Label
            data-browse={t(
                "SingleInstanceTemplate.ConfigurationTab.SEBUploadFile"
            )}
        />
      </Form.File>
    </Form.Group>
    ) : (
    <Card>
      <Card.Body>
        <FontAwesomeIcon icon={faFile} className="mr-2" />{" "}
        {`Datei: ${instanceTemplate.name}.seb`}{" "}
        <Button
            onClick={() => {
              setData("");
              handleUpdate("");

            }}
            className="btn-red btn-sm ml-2 mr-2 floatRight"
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
        <Button
            onClick={handleSEBConfigurationDownload}
            className="btn-green btn-sm ml-2 floatRight"
        >
          <FontAwesomeIcon icon={faDownload} />
        </Button>
      </Card.Body>
    </Card>
    )}
  </div>);
};

export default withTranslation()(HclViewerTerraformConfiguration);
